import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { ZIMConnectionState } from 'zego-zim-web';

import { UiStatusBarService } from '../../services/ui-status-bar.service';
import { ZimService } from '../../services/zim.service';

@Component({
  selector: 'app-network-disconnect-notice',
  standalone: true,
  templateUrl: './network-disconnect-notice.component.html',
  styleUrl: './network-disconnect-notice.component.scss',
})
export class NetworkDisconnectNoticeComponent {
  uiStatusBarService = inject(UiStatusBarService);
  zimService = inject(ZimService);
  private router = inject(Router);

  /** Màn meeting có banner riêng (MeetingNetworkNoticeComponent) → ẩn banner chung để không hiện 2 cái */
  private isInMeeting = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects.startsWith('/meeting/')),
    ),
    { initialValue: this.router.url.startsWith('/meeting/') },
  );

  isShow = computed(() => this.uiStatusBarService.showNotice() && !this.isInMeeting());

  networkNotice = computed(() => {
    const state = this.zimService.connectionState();
    switch (state) {
      case ZIMConnectionState.Connected: {
        return 'Đã kết nối';
      }
      case ZIMConnectionState.Disconnected: {
        return 'Không có kết nối mạng';
      }
      case ZIMConnectionState.Connecting: {
        return 'Đang kết nối';
      }
      case ZIMConnectionState.Reconnecting: {
        return 'Đang kết nối lại';
      }
    }
  });

  isConnecting = computed(() =>
    [ZIMConnectionState.Connecting, ZIMConnectionState.Reconnecting].includes(
      this.zimService.connectionState(),
    ),
  );
}
